// AUTO-GENERATED: 2025-10-28T19:10:34.720440Z
// 🍛 Indian recipes

export const indianRecipes = [
{
    name: "Chicken Tikka Masala",
    cuisine: "Indian",
    ingredients: ["chicken breast", "onion", "tomatoes", "ginger", "garlic", "yogurt"],
    sauces: ["garam masala", "cumin", "coriander", "cream", "butter"],
    instructions: "Marinate chicken in yogurt, garam masala, and spices for 2+ hours. Grill until charred. Make sauce: sauté onion, garlic, ginger. Add tomatoes, spices. Simmer 15 minutes. Blend smooth. Return to pan, add cream and butter. Add grilled chicken. Simmer 10 minutes. Garnish with cilantro. Serve with naan and rice.",
    time: "45 min + marinade",
    difficulty: "Medium",
    points: 75,
    servings: 2
  },
{
    name: "Butter Chicken",
    cuisine: "Indian",
    ingredients: ["chicken thighs", "tomatoes", "onion", "garlic", "ginger", "cashews"],
    sauces: ["butter", "cream", "garam masala", "kasuri methi"],
    instructions: "Marinate chicken in yogurt and spices. Grill or bake until cooked. Make sauce: sauté onion, garlic, ginger, cashews. Add tomatoes and spices. Simmer 20 minutes. Blend smooth. Return to pan, add butter and cream. Add chicken pieces. Simmer 10 minutes. Finish with kasuri methi. Serve with naan.",
    time: "50 min",
    difficulty: "Medium",
    points: 75,
    servings: 2
  },
{
    name: "Palak Paneer",
    cuisine: "Indian",
    ingredients: ["spinach", "paneer cheese", "onion", "tomatoes", "ginger", "garlic"],
    sauces: ["cumin", "garam masala", "cream", "ghee"],
    instructions: "Blanch spinach, blend to paste. Fry paneer cubes until golden, set aside. Heat ghee, add cumin seeds. Sauté onion, garlic, ginger. Add tomatoes, spices. Cook until oil separates. Add spinach paste. Simmer 10 minutes. Add cream and paneer. Simmer 5 more minutes. Garnish with cream swirl. Serve with naan or rice.",
    time: "35 min",
    difficulty: "Medium",
    points: 75,
    servings: 2
  },
{
    name: "Chana Masala",
    cuisine: "Indian",
    ingredients: ["chickpeas", "onion", "tomatoes", "ginger", "garlic"],
    sauces: ["cumin", "coriander", "garam masala", "amchur", "chili powder"],
    instructions: "Sauté onion until golden. Add ginger, garlic paste. Add tomatoes, cook until soft. Add all spices, cook until oil separates. Add drained chickpeas and water. Simmer 15-20 minutes. Mash some chickpeas to thicken sauce. Adjust seasoning. Garnish with cilantro and ginger. Serve with bhatura or rice.",
    time: "30 min",
    difficulty: "Easy",
    points: 50,
    servings: 2
  },
{
    name: "Biryani",
    cuisine: "Indian",
    ingredients: ["chicken", "basmati rice", "onion", "tomatoes", "yogurt", "mint", "cilantro"],
    sauces: ["garam masala", "saffron", "ghee", "biryani masala"],
    instructions: "Marinate chicken in yogurt and spices. Fry onions until golden. Layer in pot: rice, chicken, fried onions, mint, cilantro. Drizzle with saffron milk and ghee. Cover with tight lid. Cook on low heat 25-30 minutes (dum method). Let rest 5 minutes. Fluff gently. Serve with raita and papad.",
    time: "90 min",
    difficulty: "Hard",
    points: 150,
    servings: 2,
    special: true
  },
{
    name: "Dal Tadka",
    cuisine: "Indian",
    ingredients: ["yellow lentils", "onion", "tomatoes", "garlic", "ginger"],
    sauces: ["ghee", "cumin seeds", "turmeric", "garam masala", "kasuri methi"],
    instructions: "Pressure cook lentils with turmeric until soft. Mash slightly. Make tadka: heat ghee, add cumin seeds, then garlic, ginger, onions. Sauté until golden. Add tomatoes, spices. Cook until oil separates. Pour tadka over lentils. Simmer 10 minutes. Crush kasuri methi on top. Garnish with cilantro. Serve with rice or roti.",
    time: "35 min",
    difficulty: "Easy",
    points: 50,
    servings: 2
  },
{
    name: "Samosa",
    cuisine: "Indian",
    ingredients: ["potatoes", "peas", "onion", "flour"],
    sauces: ["cumin", "coriander", "garam masala", "amchur", "tamarind chutney", "mint chutney"],
    instructions: "Boil and mash potatoes. Mix with peas, spices. Make dough with flour, water, oil. Rest 30 minutes. Roll into ovals, cut in half. Form cone, fill with potato mixture, seal edges. Deep fry at 350°F until golden and crispy, 4-5 minutes. Drain. Serve hot with tamarind and mint chutney.",
    time: "60 min",
    difficulty: "Hard",
    points: 100,
    servings: 2
  },
{
    name: "Aloo Gobi",
    cuisine: "Indian",
    ingredients: ["potatoes", "cauliflower", "onion", "tomatoes", "ginger", "garlic"],
    sauces: ["turmeric", "cumin", "coriander", "garam masala"],
    instructions: "Heat oil, add cumin seeds. Sauté onion, ginger, garlic until golden. Add tomatoes, cook until soft. Add spices, cook until oil separates. Add potato cubes, stir to coat. Add cauliflower florets. Cover, cook on low heat 15-20 minutes, stirring occasionally, until vegetables are tender. Garnish with cilantro. Serve with roti.",
    time: "35 min",
    difficulty: "Easy",
    points: 50,
    servings: 2
  },
{
    name: "Tandoori Chicken",
    cuisine: "Indian",
    ingredients: ["chicken legs", "yogurt", "ginger", "garlic", "lemon juice"],
    sauces: ["tandoori masala", "red chili powder", "kasuri methi", "ghee"],
    instructions: "Make deep cuts in chicken. Mix yogurt with all spices, ginger-garlic paste, lemon juice. Marinate chicken 4+ hours or overnight. Preheat oven to 450°F or use grill. Place chicken on rack. Roast 35-40 minutes, basting with ghee, until charred and cooked through. Garnish with lemon wedges and onion rings. Serve with naan and mint chutney.",
    time: "50 min + marinade",
    difficulty: "Medium",
    points: 75,
    servings: 2
  },
{
    name: "Paneer Tikka",
    cuisine: "Indian",
    ingredients: ["paneer cheese", "bell peppers", "onion", "yogurt"],
    sauces: ["tandoori masala", "garam masala", "chaat masala", "lemon juice"],
    instructions: "Marinate paneer cubes and vegetables in yogurt with spices and lemon juice for 1+ hour. Thread onto skewers alternating paneer, bell peppers, onions. Grill or broil 10-12 minutes, turning occasionally, until charred spots appear. Sprinkle with chaat masala and lemon juice. Serve hot with mint chutney.",
    time: "20 min + marinade",
    difficulty: "Easy",
    points: 50,
    servings: 2
  }
];
